export const APP_CONFIG = {
  PROJECT_NAME: "Asistente de Análisis",
  AREA_NAME: "Apoyo Financiero",
  FULL_NAME: "Asistente Inteligente de Apoyo Financiero",
  INSTITUTION: "Universidad de los Andes",

  DESCRIPTION: "Analiza solicitudes, incidentes y acuerdos de nivel de servicio de la Unidad de Matrículas y Apoyo Financiero.",

  INITIAL_BOT_MESSAGE: "Hola 👋 Soy el **Asistente Inteligente de Apoyo Financiero** de la Universidad de los Andes.\n\nPuedo ayudarte a analizar:\n- **Infracciones de ANS** y causales de incumplimiento\n- **Recurrencia** de solicitudes por usuario\n- **Distribución** de solicitudes por servicio y categoría\n- **Tendencias** temporales y comparativas\n\n¿En qué puedo ayudarte hoy?",

  INPUT_PLACEHOLDER: "Pregunta sobre solicitudes, infracciones, servicios...",

  BACKEND_URL: import.meta.env.VITE_BACKEND_URL || "http://localhost:8000",
  API_ENDPOINT: "/api/v1/ask",
  DEFAULT_COLLECTION: "apoyo_financiero",
  USE_RERANKING: true,
  USE_QUERY_REWRITING: true,
};

export const getFullTitle = (): string => APP_CONFIG.FULL_NAME;

export const getBackendUrl = (): string =>
  `${APP_CONFIG.BACKEND_URL}${APP_CONFIG.API_ENDPOINT}`;

export const getStreamUrl = (): string =>
  `${APP_CONFIG.BACKEND_URL}/api/v1/ask-stream`;

export const createRequestBody = (question: string, userId?: string) => {
  const body: Record<string, unknown> = {
    question,
    collection: APP_CONFIG.DEFAULT_COLLECTION,
  };
  if (APP_CONFIG.USE_RERANKING) body.use_reranking = true;
  if (APP_CONFIG.USE_QUERY_REWRITING) body.use_query_rewriting = true;
  if (userId) body.user_id = userId;
  return body;
};
